import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";


class ModalHistorico extends Component {
    constructor(props) {
        super(props);
        this.state = {
            solicitudes: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            solicitudes: [],
        })
    }
    
    getData(){
        const { solicitudes} = this.state;

        return {solicitudes}
    }

    setSelects(data) {

    }

    onValidation(){
        const { solicitudes} = this.state;

        if(solicitudes.length>0){
            return true;
        }

        return false;
    }

    onOpen = () => {
        let selectedRows = this.props.rows();
        if(selectedRows.length>0){
            let solicitudes = [];
            selectedRows.forEach((row)=>{
                solicitudes.push(row.plan__solicitud_id);
            })
            this.setState({
                solicitudes: solicitudes,
            })
        }
    }


    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.solicitudes.habilitarhistoricos}
                onSubmit={(e) => {this.props.onSubmit(e)}}
                multiSelectIDs={this.props.multiSelectIDs()}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Habilitar Proyectos Historicos"}
                saveButtonLabel={"Confirmar"}
                buttonTitle={"Habilitar Proyectos Historicos"}
                // buttonIcon={"fa fa-history fa-lg"}
                buttonIcon={"fa fa-outdent fa-lg"}
                className={"ui-modal-dialog ui-modal-md"}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}
                onOpen={() => this.onOpen()}
                saveButton={true}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                multiselect={true}
                backdropToggle={true}
            >
                {this.props.multiSelectIDs() ? 
                <div className="ui-form">
                    <section className="ui-section-block">
                        <div className="ui-section-banner">
                            <span className="ui-icon-pill"><i className="ti ti-refresh" aria-hidden="true"></i></span>
                            <p>Proyectos a habilitar</p>
                        </div>
                        <div className="ui-scroll-list">
                            <table className="ui-table">
                                <thead>
                                    <tr>
                                        <th width={"120px"}>Codigo</th>
                                        <th>Nombre</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.rows().map((e, i)=>
                                    <tr key={i}>
                                        <td>
                                            {(e.plan__solicitud__codigo) ? (e.plan__solicitud__codigo) : ''}
                                        </td>
                                        <td>
                                            {(e.plan__solicitud__nombre) ? (e.plan__solicitud__nombre) : ''}
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>
                :
                <div className="ui-form">
                    <div className="ui-alert ui-alert-warning mb-0">Debe seleccionar una fila.</div>
                </div>
                }
            
            </ParadigmaModal>
        );
    }
}

export default ModalHistorico;



// WEBPACK FOOTER //
// ./src/views/ProyectosHistoricos/ModalHistorico.js